import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { Music, ArrowLeft, Mail } from 'lucide-react';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post('/auth/forgot-password', { email }); setSent(true); }
    catch (err) { toast.error(err.response?.data?.error || 'Errore'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#1A1A2E] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#E94560] mb-3"><Music size={28} className="text-white" /></div></div>
        <div className="bg-white rounded-2xl shadow-xl p-7">
          {sent ? (
            <div className="text-center"><Mail size={48} className="mx-auto text-pn-red mb-4" /><h2 className="text-xl font-bold mb-2">Controlla la tua email</h2><p className="text-gray-500 text-sm mb-6">Se l'email è registrata, riceverai un link per reimpostare la password.</p><Link to="/login" className="btn-primary inline-block">Torna al Login</Link></div>
          ) : (
            <form onSubmit={handleSubmit}>
              <Link to="/login" className="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-gray-600 mb-4"><ArrowLeft size={14} />Torna al login</Link>
              <h2 className="text-xl font-bold text-pn-dark mb-2">Password dimenticata?</h2>
              <p className="text-sm text-gray-500 mb-6">Inserisci la tua email e ti invieremo un link per reimpostarla.</p>
              <div className="mb-4"><label className="block text-sm font-medium mb-1">Email</label><input type="email" className="input-field" value={email} onChange={e => setEmail(e.target.value)} required placeholder="la-tua@email.com" /></div>
              <button type="submit" disabled={loading} className="w-full btn-primary py-3">{loading ? 'Invio...' : 'Invia Link Reset'}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
